import type React from 'react';

import CloseIcon from 'assets/icons/icn _ 24px  _ close_empty.svg?react';
import { useStyles } from 'components/lists/styles';
import { type PlainAvoidanceRuleInterface } from 'typedefs/avoidance';

interface AvoidanceRuleDeleteIconProps {
  rule: PlainAvoidanceRuleInterface;
  onClick: (rule: PlainAvoidanceRuleInterface) => void;
}

const AvoidanceRuleDeleteIcon: React.FC<React.PropsWithChildren<AvoidanceRuleDeleteIconProps>> = ({
  rule,
  onClick,
}) => {
  const { classes } = useStyles();

  const handleOnClick = () => {
    onClick(rule);
  };
  return <CloseIcon className={classes.listItemIcon} height={14} width={14} onClick={handleOnClick} />;
};

export default AvoidanceRuleDeleteIcon;
